export default "__VITE_ASSET__23bcfde7__"